import IconCircleCheckSolid from '@/assets/icons/font_awesome/circle-check-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { remote_workspace_user_update_permissions } from '@/state/workspace/user/remote_workspace_user_update_permissions';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';

interface Props {
  user: DTO__workspace_user;
}

export function WSButtonFeaturesAllowAllUser({ user }: Props) {
  const dispatch = use_dispatch();

  async function onClick() {
    user = user.clone({ permissions: Object.keys(ENUM__workspace_entity_feature) });

    await dispatch(remote_workspace_user_update_permissions(user));
  }

  return (
    <UI_PRIMITIVE__tooltip tooltip_title="Allow all features">
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-component'}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        Icon={IconCircleCheckSolid}
        disabled={user.permissions.length === Object.keys(ENUM__workspace_entity_feature).length}
        onClick={onClick}
        className="w-5 h-5 !p-0"
        iconClassNameBase="!w-5 !h-5"
        iconClassNameHovered="!text-component-item "
        iconClassNameNonHovered="!text-component-item-foreground"
      />
    </UI_PRIMITIVE__tooltip>
  );
}
